export const constructStrRep = (obj) => {
  if (obj.str_representation) return obj.str_representation;
  if (obj.title) return obj.title;
  return "Utskick";
};
export const detailUrl = ({ id }) => {
  return `detail/${id}`;
};